/**
 * Конфигурационные ключи проекта.
 * @typedef {Object} ProjectKeys
 * @property {string} GOOGLE_CLIENT_ID - Идентификатор клиента Google OAuth.
 * @property {string} TURNSTILE_SITE_KEY - Ключ сайта для Turnstile (аналог reCAPTCHA).
 * @property {string} GIF_TENOR_KEY - API-ключ для доступа к GIF от Tenor.
 * @property {string} AUTH_TOKEN - Токен авторизации для API.
 * @property {string} YANDEX_METRIKA_KEY - Ключ счётчика Яндекс.Метрики.
 */

/**
 * Конфигурационные ключи проекта.
 * @type {ProjectKeys}
 */
export const PROJECT_KEYS = {
  GOOGLE_CLIENT_ID: '324995823975-aier7e3oun1m4avdaqf79ueorjr8m0sg.apps.googleusercontent.com',
  TURNSTILE_SITE_KEY: '0x4AAAAAAAzO_Uuq4ZNtLCyM',
  //Ключ для использования TENOR Api для получения гифок
  GIF_TENOR_KEY: 'AIzaSyCFumx_kbSTJuV7xtJzITj1UyOtWJpYe7k',
  //Ключ для AI AGENT
  AUTH_TOKEN: 'ae8d7a6d141c0c84e13ab31db499bc0098d55043',
  //Ключ яндекс метрики
  YANDEX_METRIKA_KEY: 93064598,
}
